import { render, staticRenderFns } from "./PmReportGnbData.vue?vue&type=template&id=57a839a5&scoped=true&"
import script from "./PmReportGnbData.vue?vue&type=script&lang=js&"
export * from "./PmReportGnbData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a839a5",
  null
  
)

export default component.exports